import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AddChatroomButton(props: { templateId?: string }) {
  const [t] = useTranslation(['chatroom']);
  return (
    <Link
      to="/chatrooms/create"
      state={{
        templateId: props.templateId,
      }}
    >
      <button className="py-2 w-full border-2 border-solid border-[#38539A] rounded-3xl text-sm text-[#38539A] bg-white">
        {t('add_chatroom', '創建工作群')}
      </button>
    </Link>
  );
}
